import React, { useState, useContext } from "react";
// @mui material components
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "App";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";
import "./style.scss";
import MDButton from "components/MDButton";

const AppointmentDayCard = ({ AppDay }) => {
  const { translations } = useContext(LanguageContext);
  let navigate = useNavigate();

  const GoToDetails = () => {
    navigate("/Appointments/AppDayDetails", {
      state: {
        AppDay: AppDay,
      },
    });
  };

  const GoToDetailsSimple = () => {
    navigate("/Appointments/AppDayDetailsSimple", {
      state: {
        AppDay: AppDay,
      },
    });
  };

  const GoToSelectHours = () => {
    navigate("/Appointments/AppointmentDaySelectHour", {
      state: {
        AppDay: AppDay,
      },
    });
  };

  const GoToAccountingSessionPatientEnteries = () => {
    navigate("/Appointments/PatientAccountingSessionEnteries", {
      state: {
        AppDay: AppDay,
      },
    });
  };

  return (
    <div className="container">
      <div className="day-date">
        <div>
          {/*  <span  fontWeight="regular" color="text" className='date'>Day ID:</span>
             <p>{AppDay.id}</p> */}
        </div>
        <div>
          <span fontWeight="regular" color="text" className="date">
            {translations.appointmentAppointmentsScheduleDate}:
          </span>{" "}
          <p>{new Date(AppDay.dateDay).toLocaleDateString("en-GB").split(",")[0]}</p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="col-md-10"
      >
        <MDButton
          onClick={() => GoToDetailsSimple()}
          className="btn verify-btn"
          sx={{
            backgroundColor: "#3560AD",
            "&:hover": { backgroundColor: "#4682B4" },
            margin: "10px",
          }}
          color="text"
        >
          {" "}
          {translations.appointmentAppointmentsSchedule}
        </MDButton>
        <MDButton
          onClick={() => GoToSelectHours()}
          className="btn verify-btn"
          sx={{
            backgroundColor: "#3560AD",
            "&:hover": { backgroundColor: "#4682B4" },
            margin: "7px",
          }}
          color="text"
        >
          {translations.appointmentHours}
        </MDButton>
        <MDButton
          onClick={() => GoToAccountingSessionPatientEnteries()}
          className="btn  verify-btn"
          sx={{
            backgroundColor: "#3560AD",
            "&:hover": { backgroundColor: "#4682B4" },
            margin: "7px",
          }}
          color="text"
        >
          {translations.appointmentPatientsEnteries}
        </MDButton>
      </div>
    </div>
  );
};

export default AppointmentDayCard;
